import { Formik } from "formik";
import Loader from "../../../components/loader";
import PhoneInput from "react-phone-number-input";
import { coachPaths } from "../../../routes/coach";
import { useDispatch, useSelector } from "react-redux";
import { contactUsSchema } from "../../../utils/schema";
import { isValidPhoneNumber } from "react-phone-number-input";
import ErrorMessage from "../../../components/form/ErrorMessage";
import useAppNavigate from "../../../components/hooks/useAppNavigate";
import { contactUs } from "../../../redux/features/coach/actions/authAction";
import { useEffect, useState } from "react";
import MenuLayout from "../../../layouts/MenuLayout";
import BootCampLayout from "../../../layouts/BootCampLayout";
import ContactUsPage from "./ContactUsPage";
import { useLocation } from "react-router-dom";
import ContactSuccessModal from "../../../components/Modals/common/ContactSuccessModal";

const ContactUs = ({ data, isModalOpen, setIsModalOpen }) => {
  const { goTo } = useAppNavigate();
  const dispatch = useDispatch();


  const inquiryOptions = [
    "General Inquiry",
    "Partnership Opportunity",
    "Request for a Quote",
    "Talent Application / Freelance Inquiry",
    "Hiring or Recruitment Services",
    "Collaboration or Event Proposal",
    "Media or Press Inquiry",
    "Technical Support / Website Issue",
    "Feedback or Suggestion",
    "Other",
  ];

  const initialValues = {
    full_name: "",
    email: "",
    phone_number: "",
    address: "",
    subject: "",
    message: "",
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const handleFormSubmit = (values) => {
    const callback = (response) => {
      if (response?.success) {
        setIsModalOpen(true);
      };
    };
    dispatch(contactUs({ payload: values, callback }));
  };

  const handleCloseModal = () => {
    if (data == "landing") {
      goTo(coachPaths.BootCampList)
    } else {
      goTo(coachPaths?.Bootcamp);
    }
  };

  return (
    <div>
      <section class="ct_contact_banner_bg">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-6 mb-4 mb-lg-0">
              <div class="ct_contact_left_banner_cnt">
                <h2 class="ct_fs_50  mb-3 ct_darkblue_text">Contact Us</h2>
                <p
                  className="ct_fs_20 ct_darkblue_text"
                  style={{ maxWidth: "450px" }}
                >
                  Have a question, proposal, or just want to say hello? We’d
                  love to hear from you.
                </p>
                <Formik
                  initialValues={initialValues}
                  validationSchema={contactUsSchema}
                  onSubmit={(values, actions) => {
                    handleFormSubmit(values);
                  }}
                >
                  {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    setFieldError,
                    setFieldValue,
                  }) => (
                    <form action="" className="ct_mt_30">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="d-block ct_darkblue_text mb-2 ct_fs_14"
                            >
                              Full Name
                            </label>
                            <input
                              type="text"
                              placeholder="Full name"
                              class="form-control ct_input"
                              id="full_name"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.full_name}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="full_name"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="d-block ct_darkblue_text mb-2 ct_fs_14"
                            >
                              Email Address
                            </label>
                            <input
                              type="email"
                              placeholder="Email address"
                              class="form-control ct_input"
                              id="email"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.email}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="email"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="d-block ct_darkblue_text mb-2 ct_fs_14"
                            >
                              Phone Number
                            </label>
                            <PhoneInput
                              id="phone_number"
                              className="form-control ct_input ct_input_grey_border_1 ct_border_radius_5 ct_h_44"
                              defaultCountry="MU"
                              value={values?.phone_number}
                              onChange={(val) => {
                                const safeVal = val ?? "";
                                if (
                                  typeof safeVal === "string" &&
                                  safeVal.length > 2 &&
                                  isValidPhoneNumber(safeVal)
                                ) {
                                  setFieldValue("phone_number", safeVal);
                                } else if (!isValidPhoneNumber(safeVal)) {
                                  setFieldError(
                                    "phone_number",
                                    "Please enter valid phone number"
                                  );
                                  setFieldValue("phone_number", safeVal);
                                }
                              }}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="phone_number"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="d-block ct_darkblue_text mb-2 ct_fs_14"
                            >
                              Address
                            </label>
                            <input
                              type="text"
                              placeholder="Address"
                              class="form-control ct_input"
                              id="address"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.address}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="address"
                            />
                          </div>
                        </div>
                        <div class="col-md-6">
                          {/* <div class="form-group mb-4">
                            <label for="" class="d-block ct_darkblue_text mb-2 ct_fs_14">
                              What’s this about?
                            </label>
                            <input
                              type="text"
                              placeholder="eg. General Inquiry"
                              class="form-control ct_input"
                              id="subject"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.subject}
                            />
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="subject"
                            />
                          </div> */}
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="mb-2 d-block ct_darkblue_text ct_fs_14 ct_darkblue_text"
                            >
                              What’s this about?
                            </label>
                            <select
                              class="form-control ct_input "
                              name="subject"
                              value={values?.subject}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              <option value="">Select an option</option>
                              {inquiryOptions?.map((item, ind) => (
                                <option value={item}>{item}</option>
                              ))}
                            </select>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="subject"
                            />
                          </div>
                        </div>

                        <div class="col-md-12">
                          <div class="form-group mb-4">
                            <label
                              for=""
                              class="d-block ct_darkblue_text mb-2 ct_fs_14"
                            >
                              Message
                            </label>
                            <textarea
                              class="form-control ct_input h-auto"
                              rows="4"
                              id="message"
                              onChange={handleChange}
                              onBlur={handleBlur}
                              value={values?.message}
                            ></textarea>
                            <ErrorMessage
                              errors={errors}
                              touched={touched}
                              fieldName="message"
                            />
                          </div>
                        </div>
                      </div>

                      <div>
                        <button
                          type="button"
                          onClick={handleSubmit}
                          class="ct_yellow_btn ct_sky_blue_btn px-5"
                        >
                          {" "}
                          Send Message
                        </button>
                      </div>
                    </form>
                  )}
                </Formik>
              </div>
            </div>
            <div class="col-lg-6 mb-4 mb-lg-0">
              <div class="ct_contact_right_img text-end">
                <img src="/assets/img/contact_banner_right_img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="ct_py_100 ct_px_40">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-7 col-md-6 mb-4 mb-md-0"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_about_cnt">
                <h2 class="mb-4 ct_fs_40 ct_yellow_text">
                  We’re More Than Just Support
                </h2>

                <p className="ct_fs_18" style={{ maxWidth: "621px" }}>
                  Whether you’re launching a new idea, scaling a team, or
                  looking for expert help, Nuvio brings together coaching,
                  services, talent, and funding to move you forward - all in one
                  place. You can even start with a{" "}
                  <span class="ct_sky_blue_text">14- day free trial</span> to
                  explore the platform and see how it fits your goals.
                </p>
              </div>
            </div>
            <div
              class="col-lg-5 col-md-6 mb-4 mb-md-0"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_about_img">
                <img src="/assets/img/supporrt_img.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="ct_pb_100 ct_px_40">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12">
              <div class="ct_dark_blue_bg">
                <h4 class="ct_fs_32 ct_fw_500 text-center ct_orange_text">
                  We’d Love to Hear From You
                </h4>
                <p class="text-center text-white mb-0 ct_fs_20 ct_fw_300">
                  Let’s talk about how we can grow together.
                </p>

                <div class="container pt-5">
                  <div class="row">
                    <div

                      class="col-lg-4 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div class="ct_react_out_card">
                        <div
                          class="ct_react_out_icon"
                          style={{
                            backgroundColor: "#8ECAE6",
                            width: "46px",
                            height: "46px",
                          }}
                        >
                          <svg
                            width="20"
                            height="18"
                            viewBox="0 0 20 18"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 6C16.1667 6 15.4583 5.70833 14.875 5.125C14.2917 4.54167 14 3.83333 14 3C14 2.16667 14.2917 1.45833 14.875 0.875C15.4583 0.291667 16.1667 0 17 0C17.8333 0 18.5417 0.291667 19.125 0.875C19.7083 1.45833 20 2.16667 20 3C20 3.83333 19.7083 4.54167 19.125 5.125C18.5417 5.70833 17.8333 6 17 6ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V4C0 3.45 0.195833 2.97917 0.5875 2.5875C0.979167 2.19583 1.45 2 2 2H12.1C12.0333 2.33333 12 2.66667 12 3C12 3.33333 12.0333 3.66667 12.1 4C12.2167 4.53333 12.4083 5.02917 12.675 5.4875C12.9417 5.94583 13.2667 6.35 13.65 6.7L10 9L2 4V6L10 11L15.275 7.7C15.5583 7.8 15.8417 7.875 16.125 7.925C16.4083 7.975 16.7 8 17 8C17.5333 8 18.0583 7.91667 18.575 7.75C19.0917 7.58333 19.5667 7.33333 20 7V16C20 16.55 19.8042 17.0208 19.4125 17.4125C19.0208 17.8042 18.55 18 18 18H2Z"
                              fill="#EEEEEE"
                            />
                          </svg>
                        </div>
                        <div class="text-center mt-4">
                          <h5 class="ct_fs_20 text-white">Email Support</h5>
                          <p class="mb-0 text-white ct_fw_300">
                            Our team can respond in real time
                          </p>
                          <div class="mt-3">
                            <a
                              href="mailto:hello@nu-vio.com"
                              class="ct_yellow_text ct_fw_300"
                            >
                              hello@nu-vio.com
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div class="ct_react_out_card">
                        <div
                          class="ct_react_out_icon"
                          style={{
                            backgroundColor: "#8ECAE6",
                            width: "46px",
                            height: "46px",
                          }}
                        >
                          <svg
                            width="21"
                            height="19"
                            viewBox="0 0 21 19"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M8.33333 3.125V2.08333H12.5V3.125H14.5833V2.08333C14.5833 1.5308 14.3638 1.00089 13.9731 0.610194C13.5824 0.219493 13.0525 0 12.5 0H8.33333C7.7808 0 7.2509 0.219493 6.86019 0.610194C6.46949 1.00089 6.25 1.5308 6.25 2.08333V3.125H8.33333ZM7.12187 11.4583L0 9.08333V15.625C0.000827307 16.4535 0.330333 17.2479 0.916205 17.8338C1.50208 18.4197 2.29645 18.7492 3.125 18.75H17.7083C18.5369 18.7492 19.3313 18.4197 19.9171 17.8338C20.503 17.2479 20.8325 16.4535 20.8333 15.625V9.08333L13.7115 11.4583H7.12187Z"
                              fill="#EEEEEE"
                            />
                            <path
                              opacity="0.5"
                              d="M17.7083 3H3.125C2.2962 3 1.50134 3.32924 0.915291 3.91529C0.32924 4.50134 0 5.2962 0 6.125V8.95833L7.12188 11.3333H13.7115L20.8333 8.95833V6.125C20.8333 5.2962 20.5041 4.50134 19.918 3.91529C19.332 3.32924 18.5371 3 17.7083 3Z"
                              fill="#EEEEEE"
                            />
                          </svg>
                        </div>
                        <div class="text-center mt-4">
                          <h5 class="ct_fs_20 text-white ">
                            We’d love to welcome you{" "}
                          </h5>
                          <p class="mb-0 text-white ct_fw_300">
                            visit us in person for a coffee
                          </p>
                          <div
                            class="mt-3 mx-auto ct_fw_300"
                            style={{ maxWidth: "300px" }}
                          >
                            <a class="ct_yellow_text">
                              Office 36, 1 Exchange Building (TBE), Cybercity,
                              Ebene Mauritius
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-lg-4 mb-4 mb-lg-0"
                      data-aos="fade-down"
                      data-aos-duration="1500"
                    >
                      <div class="ct_react_out_card">
                        <div
                          class="ct_react_out_icon"
                          style={{
                            backgroundColor: "#8ECAE6",
                            width: "46px",
                            height: "46px",
                          }}
                        >
                          <svg
                            width="24"
                            height="10"
                            viewBox="0 0 24 10"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.70833 8.75L0.3125 6.40625C0.104167 6.19792 0 5.95486 0 5.67708C0 5.39931 0.104167 5.15625 0.3125 4.94792C1.84028 3.29861 3.60243 2.06163 5.59896 1.23698C7.59549 0.412326 9.61806 0 11.6667 0C13.7153 0 15.7335 0.412326 17.7214 1.23698C19.7092 2.06163 21.4757 3.29861 23.0208 4.94792C23.2292 5.15625 23.3333 5.39931 23.3333 5.67708C23.3333 5.95486 23.2292 6.19792 23.0208 6.40625L20.625 8.75C20.434 8.94097 20.2127 9.04514 19.9609 9.0625C19.7092 9.07986 19.4792 9.01042 19.2708 8.85417L16.25 6.5625C16.1111 6.45833 16.0069 6.33681 15.9375 6.19792C15.8681 6.05903 15.8333 5.90278 15.8333 5.72917V2.76042C15.1736 2.55208 14.4965 2.38715 13.8021 2.26562C13.1076 2.1441 12.3958 2.08333 11.6667 2.08333C10.9375 2.08333 10.2257 2.1441 9.53125 2.26562C8.83681 2.38715 8.15972 2.55208 7.5 2.76042V5.72917C7.5 5.90278 7.46528 6.05903 7.39583 6.19792C7.32639 6.33681 7.22222 6.45833 7.08333 6.5625L4.0625 8.85417C3.85417 9.01042 3.62413 9.07986 3.3724 9.0625C3.12066 9.04514 2.89931 8.94097 2.70833 8.75ZM5.41667 3.59375C4.91319 3.85417 4.42708 4.15365 3.95833 4.49219C3.48958 4.83073 3.00347 5.20833 2.5 5.625L3.54167 6.66667L5.41667 5.20833V3.59375ZM17.9167 3.64583V5.20833L19.7917 6.66667L20.8333 5.67708C20.3299 5.22569 19.8437 4.83507 19.375 4.50521C18.9062 4.17535 18.4201 3.88889 17.9167 3.64583Z"
                              fill="#EEEEEE"
                            />
                          </svg>
                        </div>
                        <div class="text-center mt-4">
                          <h5 class="ct_fs_20 text-white">Give Us a Call</h5>
                          <p class="mb-0 text-white ct_fw_300">
                            Reach out anytime during working hours
                          </p>
                          <div class="mt-3">
                            <a
                              href="tel:+33666925730"
                              class="ct_yellow_text ct_fw_300"
                            >
                              +33 6 66 92 57 30
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="ct_pb_100 ct_px_40 pt-0">
        <div class="container-fluid">
          <div class="row align-items-center">
            <div
              class="col-lg-5 col-md-6 mb-4 mb-md-0"
              data-aos="fade-right"
              data-aos-duration="1500"
            >
              <div class="ct_about_img">
                <img
                  src="/assets/img/faq_left_7890.png"
                  class="ct_img_h_617"
                  style={{ objectPosition: "top" }}
                  alt=""
                />
              </div>
            </div>
            <div
              class="col-lg-7 col-md-6 mb-4 mb-md-0 ps-md-5"
              data-aos="fade-left"
              data-aos-duration="1500"
            >
              <div class="ct_about_cnt">
                <h2 class="mb-0 ct_fs_40 ct_darksky_blue_text">FAQs</h2>

                <div class="ct_faq_question_main pt-5">
                  <div class="accordion" id="faq_accordionExample">
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faq_one">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_one"
                          aria-expanded="false"
                          aria-controls="collapsefaq_one"
                        >
                          Where is NUVIO based?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_one"
                        class="accordion-collapse collapse"
                        aria-labelledby="faq_one"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p
                            class="ct_fs_20 mb-3 ct_line_h_30"
                            style={{ maxWidth: "700px" }}
                          >
                            NUVIO is proudly based in Mauritius, with a growing
                            international network of coaches, freelancers, and
                            business partners.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqtwo">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Two"
                          aria-expanded="true"
                          aria-controls="collapseTwo"
                        >
                          How quickly will I get a response?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Two"
                        class="accordion-collapse collapse "
                        aria-labelledby="faqtwo"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p
                            class="ct_fs_20 mb-3 ct_line_h_30"
                            style={{ maxWidth: "700px" }}
                          >
                            We aim to reply to all messages within 24–48 hours
                            during working days. Our team makes sure every
                            inquiry receives personalized attention.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqthree">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Three"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Three"
                        >
                          Can I speak directly with someone on the NUVIO team?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Three"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqthree"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p
                            class="ct_fs_20 mb-3 ct_line_h_30"
                            style={{ maxWidth: "700px" }}
                          >
                            Absolutely! You can reach us directly by email at
                            hello@nu-vio.com or by phone during working hours,
                            we’re always happy to connect.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFour">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Four"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Four"
                        >
                          Do I need an account to use the NUVIO platform?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Four"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFour"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p
                            class="ct_fs_20 mb-3 ct_line_h_30"
                            style={{ maxWidth: "700px" }}
                          >
                            You can explore our content and events without an
                            account, but you’ll need to create one to book a
                            coach, apply as a coach, or access personalized
                            features on the platform.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="accordion-item">
                      <h2 class="accordion-header" id="faqFive">
                        <button
                          class="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapsefaq_Five"
                          aria-expanded="false"
                          aria-controls="collapsefaq_Five"
                        >
                          What makes NUVIO different from other platforms?
                        </button>
                      </h2>
                      <div
                        id="collapsefaq_Five"
                        class="accordion-collapse collapse"
                        aria-labelledby="faqFive"
                        data-bs-parent="#faq_accordionExample"
                      >
                        <div class="accordion-body">
                          <p
                            class="ct_fs_20 mb-3 ct_line_h_30"
                            style={{ maxWidth: "700px" }}
                          >
                            NUVIO goes beyond matching, we build meaningful
                            connections between companies, coaches, and
                            freelancers. Our community-driven approach blends
                            professional coaching, events, and growth
                            opportunities to help talents and businesses thrive
                            together.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        class="ct_looking_for_work_bg ct_mb_100"
        data-aos="fade-left"
        data-aos-duration="1500"
      >
        <div class="d-flex align-items-center gap-lg-5 gap-3 ct_flex_col_767 ">
          <div class="text-white">
            <h4 class="ct_fs_36 mb-4">Looking to Work With Us?</h4>
            <p class="mb-0 ct_fs_18 ct_fw_300" style={{ maxWidth: "657px" }}>
              Whether you’re ready to start or just exploring ideas, we’re here
              to support your next step
            </p>
          </div>
          <div class="ct_flex_shrink_0">
            <a class="ct_yellow_btn ct_darkblue_btn ct_flex_1">
              Explore Our Services
            </a>
          </div>
        </div>
      </section>
      <div style={{height:"46px"}}></div>

      {isModalOpen && <ContactSuccessModal onClose={handleCloseModal} />}
    </div>
  );
};

export default ContactUs;
